module.exports = __webpack_public_path__ + "img/singletrack-study-reset.88f08821.png";